import { useIntl } from "react-intl";

import { ListToggleButton } from "@/components/ListToggleButton/ListToggleButton";
import { ToggleButtonGroup } from "@/components/ToggleButtonGroup/ToggleButtonGroup";
import { ReservationType } from "@/features/bookings/types/types";

import { reservationTypesLabels } from "./labels";

type Props = {
  value: ReservationType;
  onValueChange: (value: ReservationType) => void;
};

export const OrdersTypeList = ({ value, onValueChange }: Props) => {
  const intl = useIntl();

  return (
    <ToggleButtonGroup
      value={value}
      onChange={(e, value) => {
        if (typeof value !== "string") {
          return;
        }
        onValueChange(value as ReservationType);
      }}
      orientation="vertical"
      fullWidth
      exclusive
      size="small"
      color="primary"
      aria-label={intl.formatMessage({
        defaultMessage: "Booking type",
        description:
          "Label for the booking type selector (Flights, Hotels, Trips)",
      })}
    >
      {Object.values(ReservationType).map((reservationType) => (
        <ListToggleButton
          key={reservationType}
          value={reservationType}
          selected={value === reservationType}
        >
          {intl.formatMessage(reservationTypesLabels[reservationType])}
        </ListToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
